/* src/app/components/account/manage-billing/manage-billing-list/manage-billing-list.component.scss */
.mat-mdc-row:hover {
  background-color: #eeeeee;
  cursor: pointer;
}
.mat-mdc-row.selected {
  background-color: #f5f5f5;
}
.header-row {
  background-color: #F5F5F5;
  color: #00008A;
}
.right-align {
  text-align: end;
}
th.mat-column-month {
  width: 20%;
}
th.mat-column-empty {
  width: 8%;
}
th.mat-column-documents {
  width: 12%;
}
th.mat-column-productions {
  width: 12%;
}
th.mat-column-briefcases {
  width: 12%;
}
th.mat-column-archives {
  width: 12%;
}
th.mat-column-searchIndex {
  width: 12%;
}
th.mat-column-total {
  width: 12%;
}
.mat-column-caseName,
.mat-column-totalDetail {
  cursor: default;
}
.expanded-detail-header {
  text-align: left;
  font-weight: bold;
  font-size: 12px;
  display: inline-block;
}
.expanded-detail {
  display: inline-block;
}
table {
  width: 100%;
  border-spacing: 0 8px !important;
}
tr.table-detail-row {
  height: 0;
}
tr.table-element-row:not(.table-expanded-row):hover {
  background: whitesmoke;
}
tr.table-element-row:not(.table-expanded-row):active {
  background: #efefef;
}
.table-element-row td {
  border-bottom-width: 0;
}
.table-element-detail {
  overflow: hidden;
  cursor: default;
}
.table-element-detail-expanded {
  font-size: 11px;
  padding-bottom: 20px;
  padding-top: 15px;
}
.right-align-cell {
  text-align: right;
}
:host-context(.dark-theme) .mat-mdc-row:hover {
  background-color: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) .expanded-detail-header {
  color: white;
}
:host-context(.dark-theme) .table-element-detail-expanded {
  color: ghostwhite;
}
/*# sourceMappingURL=manage-billing-list.component.css.map */
